/**
 * Copyright © 2026 Adnuntius AS.
 */
export interface CreativeDimensionOption {
  label: string;
  width: number;
  height: number;
}

export interface CreativeEditViewState {
  layouts: any[];
  showGeneralVariables: boolean;
  hasAxProductDimensions: boolean;
  allowedDimensions: CreativeDimensionOption[];
  selectedDimension: CreativeDimensionOption | undefined;
  optionalTargetTypes: string[];
  isLockedDown: boolean;
  isCreativeContentLocked: boolean;
  allComponents: any[];
  assetMatches: Record<string, any>;
  primaryHtmlAsset: any;
  isFullPage: boolean;
  allowPreviews: boolean;
  allResolved: boolean;
  selectedRetailProduct: any;
  isPureRetailCreative: boolean;
}

export function createCreativeEditViewState(): CreativeEditViewState {
  return {
    layouts: [],
    showGeneralVariables: false,
    hasAxProductDimensions: false,
    allowedDimensions: [],
    selectedDimension: undefined,
    optionalTargetTypes: [],
    isLockedDown: false,
    isCreativeContentLocked: false,
    allComponents: [],
    assetMatches: {},
    primaryHtmlAsset: undefined,
    isFullPage: false,
    allowPreviews: false,
    allResolved: false,
    selectedRetailProduct: null,
    isPureRetailCreative: false
  };
}
